<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/register.jpg" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg" style="min-height: 250px">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{$t("Register")}}</h4>
                  <p style="margin-top: 70px" v-if="registerFinished">{{$t("VerificationEmailSent")}}</p>
                </div>

                <div v-if="!registerFinished">

                  <vs-input
                          name="email"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          @keyup.enter="checkCaptcha"
                          :label-placeholder="$t('Name')"
                          v-model="name"
                          class="w-full mt-6"/>

                  <vs-input
                          name="email"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          @keyup.enter="checkCaptcha"
                          :label-placeholder="$t('LName')"
                          v-model="l_name"
                          class="w-full mt-6"/>

                  <vs-input
                      name="email"
                      icon-no-border
                      icon="icon icon-mail"
                      icon-pack="feather"
                      @keyup.enter="checkCaptcha"
                      label-placeholder="Email"
                      v-model="email"
                      class="w-full mt-6"/>

                  <vs-input
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      @keyup.enter="checkCaptcha"
                      :label-placeholder="$t('Password')"
                      v-model="password"
                      class="w-full mt-6" />

                  <vs-input
                          type="password"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          @keyup.enter="checkCaptcha"
                          :label-placeholder="$t('ConfirmPassword')"
                          v-model="passwordConfirm"
                          class="w-full mt-6" />

                  <vue-recaptcha
                          class="mt-6"
                          ref="recaptcha"
                          @verify="register"
                          @expired="onCaptchaExpired"
                          size="invisible"
                          :loadRecaptchaScript="true"
                          sitekey="6LeM2NcUAAAAAEHHCZuWNozsj_FQtT6h1yKQdPVM">
                  </vue-recaptcha>

                  <vs-button class="mt-6" :disabled="this.password !== this.passwordConfirm || this.password.length === 0 || this.name.length === 0 || this.l_name.length === 0 || this.email.length === 0" @click="checkCaptcha" type="border">{{$t("Register")}}</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

  import VueRecaptcha from 'vue-recaptcha'

export default{
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      name: "",
      l_name: "",
      email: "",
      password: "",
      passwordConfirm: "",
      registerFinished: false,
    }
  },
  methods: {
    checkCaptcha() {
      if(this.password !== this.passwordConfirm || this.password.length === 0 || this.name.length === 0 || this.l_name.length === 0 || this.email.length === 0) return;
      this.$refs.recaptcha.execute()
    },
    register(captchaToken) {

      this.$refs.recaptcha.reset();

      this.$vs.loading();
      const thisIns = this;
      this.$http.post('/api/v1/register/', {
        email: thisIns.email,
        name: thisIns.name,
        l_name: thisIns.l_name,
        password: thisIns.password,
        captcha_token: captchaToken,
      }).then(function (response) {
        thisIns.$vs.loading.close();
        thisIns.registerFinished = true;
        setTimeout(function () {
          thisIns.$router.push({ name: 'login'});
        }, 5000)
      }).catch(function () {
        thisIns.$vs.loading.close();
        thisIns.$vs.notify({
          title:'Error',
          text: "Register failed",
          color:'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      });
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    }
  }
}
</script>
